import { data } from '../../svg/Merge/data';
import { makeIcon } from '../makeIcon';

export const Merge = makeIcon(data, 'merge', 'Merge');

export default Merge;
